/**
 * The ท่าใหญ่ rules shared by every art (design docs/design/combat/2026-10-11-long-moves.md §1.1; starting values for
 * ns-balance). Main's calls (2026-10-11): an ult CAN catch a guarding foe (×`guardMult` per blow, `guardDrain` guard points
 * per blow until the guard breaks, then full); NO escape from an ult in v1.
 */
import { MONSTERS } from '../monsters';

export const LONG_ULT = {
  /** A guarding foe caught: each blow's damage × this while its guard holds (the bout's DUEL_GUARD.through). */
  guardMult: 0.35,
  /** Guard points each blow drains from a guarding foe; short of them, that blow breaks the guard (the rest land in full). */
  guardDrain: 12,
  /** Seconds after a release in which no new hold (ult or lock) can start on that foe (ult→lock, lock→ult). */
  heldImmunity: 1.5,
  /** PvE: at most this many foes caught (nearest first). */
  pveCap: 6,
  /** Caught foes are drawn up to this far toward the piece's centre at the catch (so the choreography reads). */
  pull: 1.0,
  /** The caster keeps this far from a foe it is drawn to (metres). */
  close: 1.3,
  /** Total knock-back a piece may give one foe (metres); in a bout no knock carries a foe past ring radius − `ringMargin`. */
  maxKnock: 3.0,
  ringMargin: 3.0,
  /** A monster this big (data scale) or the world's demon (`boss`) is a boss: not held, takes each beat in reach. */
  bossScale: 1.6,
  /** Seconds a `pass` travels (at the beat's start). */
  passTime: 0.2,
  /**
   * Whether the piece's own blows feed rage (the bout's +1 landed / +2 taken), per side. The caster gains none (the full
   * bar is the price); the held foe gains as from any blow taken, so it can answer back (user, 2026-10-11).
   */
  rageToCaster: false,
  rageToFoe: true,
  /** Blows of a beat land over its first share (as the lock routines). */
  blowSpread: 0.6,
} as const;

/** Whether an entity is a boss for the long moves (not held). */
export function isLongBoss(e: { kind: string; brain?: { defId: string } | null }): boolean {
  if (e.kind !== 'monster' || !e.brain) return false;
  if (e.brain.defId === 'boss') return true;
  return (MONSTERS[e.brain.defId]?.scale ?? 1) >= LONG_ULT.bossScale;
}
